import { cryptoDecrypt } from '@/utils/aes';
import { message } from 'ant-design-vue';
/*富文本编辑图片上传配置*/
const uploadConfig = {
  action: process.env.VUE_APP_BASE_API + 'upload/file?module=richText',
  // 必填参数 图片上传地址
  methods: 'POST',
  // 必填参数 图片上传方式
  token: '',
  // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
  name: '',
  // 必填参数 文件的参数名
  size: 500,
  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
  accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon' // 可选 可上传的图片格式
};

// toolbar工具栏的工具选项（默认展示全部）
const toolOptions = [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{
  header: 1
}, {
  header: 2
}], [{
  list: 'ordered'
}, {
  list: 'bullet'
}], [{
  script: 'sub'
}, {
  script: 'super'
}], [{
  indent: '-1'
}, {
  indent: '+1'
}], [{
  direction: 'rtl'
}], [{
  size: ['small', false, 'large', 'huge']
}], [{
  header: [1, 2, 3, 4, 5, 6, false]
}], [{
  color: []
}, {
  background: []
}], [{
  font: []
}], [{
  align: []
}], ['clean'], ['link', 'image', 'video']];
const handlers = {
  image: function image() {
    var self = this;
    var fileInput = this.container.querySelector('input.ql-image[type=file]');
    if (fileInput === null) {
      fileInput = document.createElement('input');
      fileInput.setAttribute('type', 'file');
      // 设置图片参数名
      if (uploadConfig.name) {
        fileInput.setAttribute('name', uploadConfig.name);
      }
      // 可设置上传图片的格式
      fileInput.setAttribute('accept', uploadConfig.accept);
      fileInput.classList.add('ql-image');
      // 监听选择文件
      fileInput.addEventListener('change', function () {
        const isLt5M = fileInput.files[0].size / 1024 / 1024 < 2;
        if (!isLt5M) {
          return message.error('文件过大，请选择2M以下文件上传');
        }
        // 创建formData
        var formData = new FormData();
        // console.log(fileInput,54545)
        formData.append('file', fileInput.files[0]);
        // formData.append(uploadConfig.name, );
        // formData.append('object','product');
        // 如果需要token且存在token
        if (uploadConfig.token) {
          formData.append('token', uploadConfig.token);
        }
        // 图片上传
        var xhr = new XMLHttpRequest();
        xhr.open(uploadConfig.methods, uploadConfig.action, true);
        // 上传数据成功，会触发
        xhr.onload = function (e) {
          if (xhr.status === 200) {
            var data = JSON.parse(xhr.responseText);
            console.log(data, 111);
            if (data.code != 200) {
              message.error(data.message || '');
              return false;
            }
            let url = '';
            if (process.env.NODE_ENV === 'production') {
              url = cryptoDecrypt(data.data).fileTempUrl;
            } else {
              url = data.data.fileTempUrl;
            }
            console.log(url);
            let length = self.quill.getSelection(true).index;
            //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
            self.quill.insertEmbed(length, 'image', url);
            self.quill.setSelection(length + 1);
          }
          fileInput.value = '';
        };
        // 开始上传数据
        xhr.upload.onloadstart = function (e) {
          fileInput.value = '';
        };
        // 当发生网络异常的时候会触发，如果上传数据的过程还未结束
        xhr.upload.onerror = function (e) {};
        // 上传数据完成（成功或者失败）时会触发
        xhr.upload.onloadend = function (e) {
          // console.log('上传结束')
        };
        xhr.setRequestHeader('X-Dispatch', 'Upload');
        xhr.setRequestHeader('X-Version', 'upload');
        xhr.send(formData);
      });
      this.container.appendChild(fileInput);
    }
    fileInput.click();
  }
};
export default {
  placeholder: '',
  theme: 'snow',
  // 主题
  modules: {
    toolbar: {
      container: toolOptions,
      // 工具栏选项
      handlers: handlers // 事件重写
    }
  }
};